module.exports = __webpack_public_path__ + "static/media/call-ok-banner.d7c1394a.svg";